import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const OPTIONS = [
  ["system", "Follow phone", Monitor],
  ["light", "Light", Sun],
  ["dark", "Dark", Moon],
];

export function AppearanceCard() {
  const { preference, setTheme, systemTheme } = useTheme();
  return (
    <div className="card-tactical rounded-md p-6" data-testid="appearance-card">
      <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B]">Appearance</div>
      <h2 className="font-display font-black text-2xl mt-1">Light or dark</h2>
      <p className="text-sm opacity-60 mt-1">"Follow phone" switches automatically with your device setting{preference === "system" ? ` (currently ${systemTheme}).` : "."} This page always shows dark; your choice applies everywhere else.</p>
      <div className="grid grid-cols-3 gap-2 mt-4" data-testid="appearance-options">
        {OPTIONS.map(([k, label, Icon]) => (
          <button key={k} type="button" onClick={() => setTheme(k)} data-testid={`appearance-${k}`} aria-pressed={preference === k}
            className={`flex flex-col items-center gap-2 py-4 rounded-md border text-[10px] tracking-widest uppercase transition-colors ${preference === k ? "border-[#83B68B] bg-[#83B68B]/10 text-[#83B68B]" : "border-border opacity-70 hover:opacity-100"}`}>
            <Icon className="w-5 h-5" /> {label}
          </button>
        ))}
      </div>
    </div>
  );
}
